import { z } from 'zod'

import { TripPaymentMethodConfigPayload, UserPaymentMethods, WithPaymentMethods } from '@/travelsuit'

import { getGGClient, RequestOverrides } from './GetGoingClient'

export async function getCommonPaymentMethods(tripId: number, overrides?: RequestOverrides) {
	return getGGClient()
		.request('GET', `trips/${tripId}/payment_methods`, {
			params: { different_traveler_credit_cards: false },
			responseSchema: z.any(),
			...overrides,
		})
		.then((r) => r.data as WithPaymentMethods)
}

getCommonPaymentMethods.queryKey = (tripId: number) => ['trips', tripId, 'payment_methods', false]

export async function getUsersPaymentMethods(tripId: number, overrides?: RequestOverrides) {
	return getGGClient()
		.request('GET', `trips/${tripId}/payment_methods`, {
			params: { different_traveler_credit_cards: true },
			responseSchema: z.any(),
			...overrides,
		})
		.then((r) => r.data as UserPaymentMethods[])
}

getUsersPaymentMethods.queryKey = (tripId: number) => ['trips', tripId, 'payment_methods', true]

export async function updatePaymentMethods(
	tripId: number,
	tripPaymentMethodPayload: TripPaymentMethodConfigPayload,
	overrides?: RequestOverrides,
) {
	await getGGClient().request('PUT', `trips/${tripId}/payment_methods`, {
		data: { tripId, ...tripPaymentMethodPayload },
		requestSchema: z.any(),
		...overrides,
	})
}
